import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import TokenStats from './TokenStats';

import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import netOverlay from '../../assets/images/net-overlay.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';
import ChainCircle, { RightArrow, RefreshLogo } from '../Svg/index';


import SocialIconsInFooter from './SocialIconsInFooter.js';
import ShowIntro from './ShowIntro';
import styles from './stylesheets/GuestUserFooter.module.css';
export class GuestUserFooter extends Component {
    render() {
        return (
            <div className={styles.guestUserFooter}>
                <div className={styles.bgOverlay}>
                    <div className={styles.circle} style={{'left': '-210px' }}>

                    </div>
                    <div className={styles.circle} style={{ left: 'calc((100% - 420px) / 2)' }}>
                        <div className={styles.zuzCompany}>
                            <p>(C) ZUZ FINANCE 2021</p>
                        </div>
                    </div>
                    <div className={styles.circle} style={{ right: '-210px' }}>

                    </div>
                    <div className={styles.userProfile}>
                        <ShowIntro></ShowIntro>

                    </div>
                </div>
                <SocialIconsInFooter></SocialIconsInFooter>
            </div>
        )
    }
}

export default GuestUserFooter
